// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "锅炉与锅炉房设计",
      "tec": "申宇杨利",
      "week": "5-7,11-16周",
      "add": "教学楼D座514能动AISEC"
    },
    {
      "sub": "集控运行",
      "tec": "张旭",
      "week": "1-7,11-13周",
      "add": "教学楼D座425能动AISEC"
    },
    {
      "sub": "燃气轮机与联合循环",
      "tec": "姜鑫高宇",
      "week": "1,3-7,11-14周",
      "add": "教学楼D座514能动AISEC"
    },
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "环境工程学",
      "tec": "张磊",
      "week": "1-6周",
      "add": "教学楼D座513能动AISEC"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "热力发电厂",
      "tec": "夏永军",
      "week": "1-7,11-16周",
      "add": "教学楼D座425能动AISEC"
    },
    {
      "sub": "集控运行",
      "tec": "张旭",
      "week": "1-7,11-13周",
      "add": "教学楼D座425能动AISEC"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "环境工程学",
      "tec": "张磊",
      "week": "1-6周",
      "add": "教学楼D座513能动AISEC"
    },
    {
      "sub": "燃气轮机与联合循环",
      "tec": "姜鑫高宇",
      "week": "1,3,5,7,11,13周",
      "add": "教学楼D座514能动AISEC"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "热力发电厂",
      "tec": "夏永军",
      "week": "1,3,5,7,11,13,15周",
      "add": "教学楼D座425能动AISEC"
    },
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
